import { useCallback, useState } from "react";

import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import ReferralsModal from "./referrals-modal.component";

const ReferralsButton = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const closeModal = useCallback(() => {
    setModalIsOpen(false);
  }, []);

  const openModal = useCallback(() => {
    setModalIsOpen(true);
  }, []);

  return (
    <>
      <Tooltip title="Earn $500">
        <IconButton size="medium" onClick={openModal}>
          🤝
        </IconButton>
      </Tooltip>

      <ReferralsModal isOpen={modalIsOpen} onClose={closeModal} />
    </>
  );
};

export default ReferralsButton;
